<div class="container">
  <div class="column menu" [class.active]="menuOpened">
    <a href="#" routerLink="/dashboard" class="logo" tabindex="0">
      <img priority ngSrc="/logo.png" alt="logo" width="120" height="48">
    </a>

    <a aria-label="Toggle zichtbaarheid menu" class="menu-toggle"
      (click)="toggleMenu()"
      (keydown.enter)="toggleMenu()"
      tabindex="0">
      <app-icon [icon]="menuOpened ? 'close' : 'bars'"></app-icon>
    </a>

    <div class="menu-wrapper">
      <a
        class="menu-item"
        [class.blur]="blurred"
        routerLink="/dashboard"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{exact: true}"
        tabindex="0" (click)="closeMenu()"
        >
        <app-icon icon="square-poll-vertical"></app-icon>
        <span>Overzicht</span>
      </a>
      <a class="menu-item" [class.blur]="blurred" routerLink="/dashboard/subscription" routerLinkActive="active" tabindex="0" (click)="closeMenu()">
        <app-icon icon="address-card"></app-icon>
        <span>Abonnement</span>
      </a>
      <a class="menu-item" [class.blur]="blurred" routerLink="/dashboard/order" routerLinkActive="active" tabindex="0" (click)="closeMenu()">
        <app-icon icon="shopping-cart"></app-icon>
        <span>Bestellen</span>
      </a>
      <a class="menu-item" [class.blur]="blurred" routerLink="/dashboard/invoice" routerLinkActive="active" tabindex="0" (click)="closeMenu()">
        <app-icon icon="file-lines"></app-icon>
        <span>Facturen</span>
      </a>
      <a class="menu-item" [class.blur]="blurred" routerLink="/dashboard/customersupport" routerLinkActive="active" tabindex="0" (click)="closeMenu()">
        <app-icon icon="headset"></app-icon>
        <span>Klantenservice</span>
      </a>
      <a class="menu-item" [class.blur]="blurred" routerLink="/dashboard/myaccount" routerLinkActive="active" tabindex="0" (click)="closeMenu()">
        <app-icon icon="user"></app-icon>
        <span>Mijn gegevens</span>
      </a>
      @if (isSingleScope()) {
        <div class="align-center text-center nav-login-block padding">
          <div class="text-subtitle">Log in om alle functionaliteiten te kunnen gebruiken.</div>
          <app-button
            (click)="logInToChangeScope()">
            Inloggen
          </app-button>
        </div>
      }
    </div>
  </div>
  <div class="column content">
    <div class="top-bar">
      <div class="top-bar-start">
        @if (blurred && showBackButton) {
          <a aria-label="Toggle zichtbaarheid menu" (click)="toggleMenu()" (keydown.enter)="toggleMenu()" tabindex="0">
            <app-icon icon="bars"></app-icon>
          </a>
        }
        @if (!blurred && showBackButton) {
          <a aria-label="Terug" (click)="location.back()" (keydown.enter)="location.back()" tabindex="0">
            <app-icon icon="arrow-left"></app-icon>
          </a>
        }
        <div class="page-info">
          <h1 class="top-bar-title">{{ title }}</h1>
          <p class="top-bar-subtitle">{{ subtitle }}</p>
        </div>
      </div>
      <div class="top-bar-end">
        <div class="user-info">
          <div class="user-name">
            <span>{{ (authService.getActiveRelation() | async)?.full_name }}</span>
          </div>
          <div class="user-address">
            <span>{{ authService.getActiveRelation() | async | address }}</span>
          </div>
        </div>
        @if (multiple) {
          <a aria-label="Kies andere relatie" id="btn-choose" routerLink="/login/choose-relation">
            <app-icon icon="fa-light fa-users"></app-icon>
          </a>
        }
        <a aria-label="Uitloggen" id="btn-logout" (click)="authMenuHandle()" (keyup.enter)="this.authMenuHandle()" tabindex="0">
          <app-icon icon="arrow-right-from-bracket"></app-icon>
        </a>
      </div>
    </div>

    <router-outlet/>
  </div>
</div>
